import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { TextField } from 'edenred-ui';

import { createRules } from '@epi-forms/helpers';
import {
  maxLength,
  required as requiredValidation
} from '@epi-helpers/formHelpers/validators';
import { IPersonalDataField } from '@epi-models/pages/Beneficiaries';
import { apiToDefaultDateFormat } from '@epi-helpers/dateHelper';

export const PersonalDataField = ({
  label,
  validate,
  name,
  required = false,
  disabled = false,
  isDataField = false
}: IPersonalDataField) => {
  const { control } = useFormContext();
  const defaultValidators = [requiredValidation, maxLength(50)];
  const rules = createRules(validate || defaultValidators);

  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  const formattedValue = isDataField
    ? apiToDefaultDateFormat(value)
    : value ?? '';

  return (
    <TextField
      id={name}
      label={label}
      value={formattedValue}
      onChange={onChange}
      readOnly={disabled}
      error={!!error}
      helperText={error?.message}
      required={required}
    />
  );
};
